module.exports = __webpack_public_path__ + "static/media/img_categoria_parent.df7456f9.png";